/* Stop marquee sections from scrolling when a single run of their content
   already fits the visible width. The theme's marquee-component keeps the
   CSS animation off any element carrying [data-disabled], so this only has
   to measure and toggle that attribute; gb-custom.css centres the static
   run and hides the filler copies marquee.js clones in. */
(function () {
  function check(m) {
    var run = m.querySelector('.marquee__repeated-items');
    if (!run) return;
    /* Desktop: always let the marquee auto-scroll (leftward, per the section's
       movement_direction). Only mobile keeps the static single-run treatment. */
    if (window.matchMedia('(min-width: 750px)').matches) {
      m.removeAttribute('data-disabled');
      return;
    }
    var fits = run.getBoundingClientRect().width <= m.clientWidth + 1;
    if (fits) {
      m.setAttribute('data-disabled', '');
    } else {
      m.removeAttribute('data-disabled');
    }
  }

  /* Header announcement bar: gb-custom.css keeps its text nowrap on mobile
     and animates it across - but only .gb-announce-scroll animates, stamped
     here when the text genuinely overflows the viewport it scrolls in (the
     part of the slide left over beside the "Shop now" chip). */
  function checkAnnouncements() {
    document.querySelectorAll('.announcement-bar__slide').forEach(function (slide) {
      var text = slide.querySelector('.announcement-bar__text');
      if (!text) return;
      var box = slide.querySelector('.announcement-bar__viewport') || slide;
      text.classList.toggle('gb-announce-scroll', text.scrollWidth > box.clientWidth + 1);
    });
  }

  function checkAll() {
    document.querySelectorAll('marquee-component').forEach(check);
    checkAnnouncements();
  }

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(checkAll, 300);
  });

  checkAll();
  /* re-measure once webfonts land; the first pass may have used a fallback
     font with different metrics */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(checkAll);
  }
})();
